"use strict";

angular.module('rmApp')
    .config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('trialended', {
                url: "/trialended",
                views: {
                    'trialoverview': {
                        templateUrl: '/partial/app.trialended',
                        // controller: 'ContactOverviewCtrl',
                        // controllerAs: 'contactCtrl'
                    }
                },
                onEnter: ['bladesManager', function (bladesManager) {

                    bladesManager.clearAll();
                    bladesManager.insert({viewName: 'trialoverview', size: 'full'});
                }],
            }).state('buynow', {
                url: "/buynow",
                views: {
                    'buynow': {
                        templateUrl: '/partial/app.buynow',
                        // controller: 'ContactOverviewCtrl',
                        // controllerAs: 'contactCtrl'
                    }
                },
                onEnter: ['bladesManager', function (bladesManager) {

                    bladesManager.clearAll();
                    bladesManager.insert({viewName: 'buynow', size: 'full'});
                }],
            });
    }]);
